<template>
    <span>
        <template v-for="splitWord in splitLine">
            <template v-for="(text, index) in splitWord">
                <span style="white-space: nowrap">
                    {{text}}{{index < splitWord.length - 1 ? interText : ''}}
                </span>
                {{index < splitWord.length - 1 ? ' ' : ''}}
            </template>
            <br>
        </template>
    </span>
</template>

<script>
    export default {
        name: "HangulWordWrapText",

        props: {
            text: {
                type: String,
                required: true,
            },

            splitLineRegex: {
                default: () => /<br>/,
            },
            splitRegex: {
                default: () => / +/,
            },

            interText: {
                default: () => ' ',
            },

        },

        computed: {
            splitLine() {
                return this.text.split(this.splitLineRegex)
                           .map(line => line.split(this.splitRegex));
            },
        }
    }
</script>

<style scoped>

</style>
